query manualResultingEvents(
  $condition: EventCondition,
  $filter: EventFilter,
) {
  events: allEvents(
    orderBy: STARTS_AT_DESC,
    condition: $condition,
    filter: $filter
  ) {
    nodes {
      eventId
      eventName
      limbo
      matchState
      eventType
      sport {
        sportLabel
        sportId
      }
      startsAt
      isUsaView
      competition {
        competitionId
        competitionName
      }
      competitors
      eventMarketsResultingStatusesByEventId {
        nodes {
          notResultedMarketCount
          operatorId
        }
      }
      source
    }
    totalCount
  }
}
